import { Divider, VStack, View } from "@gluestack-ui/themed";
import { InvoiceReceiptController } from "./controller";
import { TransactionInfoSection } from "@repo/core/components/receipt/sections/TransactionInfoSection";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import {
  convertApiNumberStringToNumber,
  numberToBrl
} from "@repo/core/utils/currency.utils";
import { ReceiptFooterSection } from "@repo/core/components/receipt/sections/ReceiptFooterSection";
import { formatDateTime } from "@repo/core/utils/date.utils";
import { TransactionPaymentMethodEnum } from "@repo/core/constants/transactions";
import { ShareButton } from "@repo/core/components/core/ShareButton";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const InvoiceReceipt = () => {
  const {
    back,
    isMobile,
    handleGoToSales,
    data,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  } = InvoiceReceiptController();
  return (
    <Scaffolds.Root
      title="Comprovante de Transação"
      onBackPress={back}
      rightIcon="times"
      rightIconSize={20}
      rightWebLabel="Fechar"
      onPressRightIcon={handleGoToSales}
      statusBarVariant={StatusBarVariantEnum.LIGHT}
    >
      <Scaffolds.Form
        footerContent={
          <View
            w="$full"
            gap="$4"
            flexDirection={!isMobile ? "row-reverse" : "column"}
            pt={isMobile ? "$4" : "$12"}
            pb="$4"
            justifyContent="flex-end"
          >
            <ShareButton
              flex={isMobile ? undefined : 1}
              isLoading={isLoading}
              onPress={handleCaptureAndGeneratePDF}
            />
          </View>
        }
      >
        <View flex={1} ref={viewRef} collapsable={false}>
          <VStack alignItems="center" gap={8} p="$4">
            <Icon
              name="receipt"
              color="$primary500"
              size={46}
              variant="solid"
            />
            <Text fontSize="$2xl" fontWeight={600}>
              {numberToBrl(parseFloat(data.valor))}
            </Text>
            <Text>{data.lojista}</Text>
          </VStack>
          <Divider />
          <VStack px="$6">
            <TransactionInfoSection
              title="Dados Gerais"
              icon="list"
              dateTime={formatDateTime(data?.data, data?.hora)}
              paymentMethod={TransactionPaymentMethodEnum.CREDIT}
              totalValue={convertApiNumberStringToNumber(data.valor)}
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <StoreInfoSection
              title="Destino"
              icon="circle-arrow-down"
              name={data.lojista}
              nsuProcessor={data.nsuProcessadora}
              nsuTerminal={data.nsuTerminal}
              address={data.endereco}
              cnpj={data.cnpj}
              phone={data.fone}
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <ClientInfoSection
              title="Origem"
              icon="circle-arrow-up"
              name={data.cliente}
              fone={data.foneCliente}
              card={data.plastico}
            />
          </VStack>
          <ReceiptFooterSection transactionId="5661214er5f-25df8-982d-h87u-b2y6e3a6c4f88b" />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default InvoiceReceipt;
